<template>
	<div>
		<meta
			name="viewport"
			content="width=device-width, initial-scale=1.0, maximum-scale=1.0, 
     user-scalable=0"
		/>
		<qrcode-stream
			:track="selected.value"
			:torch="torchActive"
			@init="logErrors"
			@decode="onDecode"
			:camera="selectedCameraId ? { deviceId: selectedCameraId } : camera"
			class="qrReader"
			:key="qrReaderKey"
		>
			<!-- 상단 메뉴 -->
			<v-layout :class="$vuetify.breakpoint.xs ? 'qrHeadxs' : 'qrHead'">
				<v-flex class="qrTitle">QR 리더기</v-flex>
			</v-layout>
			<!-- qr 인증성공 메세지 -->
			<div class="confirmation" justify-center v-show="alertCard1">
				<v-card class="alertCard1" color="yellow">
					방문등록 해주셔서 감사합니다. <br />
					직원이 안내 도와드리겠습니다.
				</v-card>
			</div>
			<!-- 이미 인증됨 메세지 -->
			<div class="confirmation" justify-center v-show="alertCard2">
				<v-card class="alertCard2" color="error">
					이미 방문등록 되었습니다. <br />
					직원이 안내 도와드리겠습니다. <br />잠시만 기다려주세요.</v-card
				>
			</div>
			<!-- qr 인증박스 -->
			<v-layout :class="$vuetify.breakpoint.xs ? 'qrMiddlexs' : 'qrMiddle'" align-center justify-center>
				<div :class="nowWidth"></div>
			</v-layout>
			<!-- 촬영 버튼 -->
			<btn :btn="btn" btn_icon="mdi-camera-flip-outline" btn_txt="카메라 전환" @click="switchCamera"></btn>
			<!-- USB 카메라 전환 버튼 -->
			<btn :btn="usbBtn" btn_icon="mdi-usb" btn_txt="USB 카메라" @click="switchToUsbCamera"></btn>
		</qrcode-stream>
	</div>
</template>

<script>
// import VueQrcode from 'vue-qrcode'
import { btn } from '@/components/index.js'
export default {
	components: {
		btn,
	},
	data() {
		const options = [
			{ text: 'nothing (default)', value: undefined },
			{ text: 'outline', value: this.paintOutline },
			{ text: 'centered text', value: this.paintCenterText },
			{ text: 'bounding box', value: this.paintBoundingBox },
		]

		const selected = options[1]

		return {
			qrReaderKey: 0,
			selected,
			options,
			groupCodes: [],
			//카메라 방향
			camera: 'front',
			//카메라 유무 체크
			noRearCamera: false,
			noFrontCamera: false,
			// USB 카메라 장치 ID
			selectedCameraId: null,
			// flash light
			torchActive: false,
			torchNotSupported: false,
			// 찍은 qr 정보
			result: null,
			// 인증완료 카드 model
			alertCard1: false,
			alertCard2: false,
			alertCard3: false,
			alertCard4: false,
			// 촬영 버튼
			btn: {
				block: true,
				dark: true,
				height: '7%',
				color: '#7DC269',
				class: 'qrCapture',
				icon: true,
				iconSize: '24px',
			},
			// USB 카메라 버튼
			usbBtn: {
				block: true,
				dark: true,
				height: '7%',
				color: '#2196F3',
				class: 'qrCapture',
				icon: true,
				iconSize: '24px',
			},

			// info 다이어로그
			qrinfoDialog: { dialog: false, title: 'Test Business Name' },
			// 음성 재생 데이터
			voiceList: [],
			greetingSpeech: new window.SpeechSynthesisUtterance(),
			synth: window.speechSynthesis,
			/// user 이름
			userData: {},
			greetingUser: '',
			greetingUser2: '이미 인증되었습니다',
			greetingUser1: '예약일시를 확인하세요',
			greetingNum: '',
			windowWidth: window.innerWidth,
			windowHeight: window.innerHeight,
			groupdata: {},
			/// 상담자 reserve user 데이터
			reservedUser: {},

			// 오늘 대기 번호
			waitNum: '',

			title: '', // (reservedays) 사업지명
			tplCode: '', // tplCode
			messageData: {}, // 알림톡 전송 정보
			originMsg: '',
			voiceSystemsList: {
				StartWork: { voice: '', version: 0 },
				LeaveWork: { voice: '', version: 0 },
				AlreadyStartWork: { voice: '', version: 0 },
				AlreadyLeaveWork: { voice: '', version: 0 },
			},
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.windowWidth = window.innerWidth
			})
			window.addEventListener('resize', () => {
				this.windowHeight = window.innerHeight
			})
			if (this.windowWidth <= 375) {
				return 'middleSquarexxxs'
			} else if (this.windowWidth <= 375) {
				return 'middleSquarexxs'
			} else if (this.windowWidth <= 425) {
				return 'middleSquarexs'
			} else if (this.windowWidth <= 768) {
				return 'middleSquaresm'
			} else if (this.windowWidth <= 1024) {
				return 'middleSquaremd'
			} else {
				return 'middleSquare'
			}
		},
		nowHeight() {
			window.addEventListener('resize', () => {
				this.windowHeight = window.innerHeight
			})
			return this.windowHeight
		},
	},
	methods: {
		paintOutline(detectedCodes, ctx) {
			for (const detectedCode of detectedCodes) {
				const [firstPoint, ...otherPoints] = detectedCode.cornerPoints

				ctx.strokeStyle = 'yellow'

				ctx.beginPath()
				ctx.moveTo(firstPoint.x, firstPoint.y)
				for (const { x, y } of otherPoints) {
					ctx.lineTo(x, y)
				}
				ctx.lineTo(firstPoint.x, firstPoint.y)
				ctx.closePath()
				ctx.stroke()
			}
		},

		paintBoundingBox(detectedCodes, ctx) {
			for (const detectedCode of detectedCodes) {
				const {
					boundingBox: { x, y, width, height },
				} = detectedCode

				ctx.lineWidth = 2
				ctx.strokeStyle = '#007bff'
				ctx.strokeRect(x, y, width, height)
			}
		},

		paintCenterText(detectedCodes, ctx) {
			for (const detectedCode of detectedCodes) {
				const { boundingBox, rawValue } = detectedCode

				const centerX = boundingBox.x + boundingBox.width / 2
				const centerY = boundingBox.y + boundingBox.height / 2

				const fontSize = Math.max(12, (50 * boundingBox.width) / ctx.canvas.width)

				ctx.font = `bold ${fontSize}px sans-serif`
				ctx.textAlign = 'center'

				ctx.lineWidth = 3
				ctx.strokeStyle = '#35495e'
				ctx.strokeText(detectedCode.rawValue, centerX, centerY)

				ctx.fillStyle = '#5cb984'
				ctx.fillText(rawValue, centerX, centerY)
			}
		},

		switchCamera() {
			//카메라 변경
			switch (this.camera) {
				case 'front':
					this.camera = 'rear'
					break
				case 'rear':
					this.camera = 'front'
					break
			}
		},
		async logErrors(promise) {
			try {
				//카메라 변경
				await promise
			} catch (error) {
				const triedFrontCamera = this.camera === 'front'
				const triedRearCamera = this.camera === 'rear'

				const cameraMissingError = error.name === 'OverconstrainedError'

				if (triedRearCamera && cameraMissingError) {
					this.noRearCamera = true
				}

				if (triedFrontCamera && cameraMissingError) {
					this.noFrontCamera = true
				}

				console.error(error)
			}
			try {
				//플래시라이트 on off
				const { capabilities } = await promise

				this.torchNotSupported = !capabilities.torch
			} catch (error) {
				console.error(error)
			}
			try {
				//qr 읽기
				await promise
			} catch (e) {
				console.error(e)
			}
		},
		QRUser(content) {
			if (!content) {
				return window.location.reload()
			}
			const data = {
				id: content,
			}
			this.$store
				.dispatch('checkReserveusers', data)
				.then(res => {
					if (res.data.reserveusers.length === 0) {
						alert('해당 QR코드가 존재하지 않습니다. 다시 확인 해주세요.')
						return
					}
					if (res.data.reserveusers[0].reserveState === 'visit') {
						this.alertCard2 = true
						setTimeout(() => {
							this.alertCard2 = false
						}, 3000)
						return
					}
					const waitngDatas = {
						id: content,
						reserveState: 'visit',
					}
					this.$store.dispatch('updateReserveuser', waitngDatas).then(() => {
						this.alertCard1 = true
						setTimeout(() => {
							this.alertCard1 = false
						}, 3000)
					})
				})
				.catch(err => {
					this.$store.state.loading = false
					console.log({ err })
				})
			this.pause()
			setTimeout(() => {
				this.unpause()
			}, 500)
		},
		async onDecode(content) {
			if (!content) {
				return window.location.reload()
			}
			this.QRUser(content)
			setTimeout(() => {
				this.qrReaderKey++
			}, 1000)
		},
		unpause() {
			this.camera = 'auto'
		},
		pause() {
			this.camera = 'off'
		},
		timeout(ms) {
			return new Promise(resolve => {
				window.setTimeout(resolve, ms)
			})
		},

		// USB 카메라 감지 및 초기화
		async initCamera() {
			try {
				// 사용 가능한 비디오 입력 장치 목록 가져오기
				const devices = await navigator.mediaDevices.enumerateDevices()
				const videoDevices = devices.filter(device => device.kind === 'videoinput')

				console.log('사용 가능한 카메라 장치:', videoDevices)

				if (videoDevices.length === 0) {
					alert('사용 가능한 카메라가 없습니다. USB 카메라를 연결해주세요.')
					return
				}

				// USB 카메라 우선 선택 (일반적으로 USB 카메라는 후순위에 위치)
				const usbCamera = videoDevices.find(
					device =>
						device.label.toLowerCase().includes('usb') ||
						device.label.toLowerCase().includes('camera') ||
						!device.label.toLowerCase().includes('integrated'),
				)

				if (usbCamera) {
					console.log('USB 카메라 감지:', usbCamera.label)
					// USB 카메라를 기본으로 설정
					this.selectedCameraId = usbCamera.deviceId
				}

				// 카메라 권한 요청 및 초기화
				const stream = await navigator.mediaDevices.getUserMedia({
					video: {
						deviceId: this.selectedCameraId ? { exact: this.selectedCameraId } : undefined,
						width: { ideal: 1280 },
						height: { ideal: 720 },
						facingMode: this.camera === 'front' ? 'user' : 'environment',
					},
				})

				console.log('카메라 스트림 초기화 완료')
				// 스트림 정리 (qrcode-stream이 자체적으로 관리)
				stream.getTracks().forEach(track => track.stop())
			} catch (error) {
				console.error('카메라 초기화 오류:', error)
				if (error.name === 'NotAllowedError') {
					alert('카메라 권한이 필요합니다. 브라우저 설정에서 카메라 권한을 허용해주세요.')
				} else if (error.name === 'NotFoundError') {
					alert('카메라를 찾을 수 없습니다. USB 카메라가 제대로 연결되었는지 확인해주세요.')
				} else {
					alert('카메라 연결에 문제가 발생했습니다: ' + error.message)
				}
			}
		},

		// 카메라 장치 변경
		async switchToUsbCamera() {
			try {
				const devices = await navigator.mediaDevices.enumerateDevices()
				const videoDevices = devices.filter(device => device.kind === 'videoinput')

				// USB 카메라 찾기
				const usbCamera = videoDevices.find(
					device => device.label.toLowerCase().includes('usb') || device.label.toLowerCase().includes('camera'),
				)

				if (usbCamera) {
					this.selectedCameraId = usbCamera.deviceId
					this.qrReaderKey++ // QR 리더 재초기화
					console.log('USB 카메라로 전환:', usbCamera.label)
				} else {
					alert('USB 카메라를 찾을 수 없습니다.')
				}
			} catch (error) {
				console.error('USB 카메라 전환 오류:', error)
			}
		},

		hides() {},
	},
	async created() {
		// 페이지 로드 시 카메라 초기화
		await this.initCamera()
	},
}
</script>

<style lang="scss">
.qrReader {
	height: 100vh !important;
}
/// 상단 메뉴 css
.qrHead {
	height: 9%;
	padding: 2vh 0px 0vw 2vw;
}
.qrHeadxs {
	height: 7%;
	padding: 2vh 0px 0vw 2vw;
}
// 상단 사업지명
.qrTitle {
	font-size: 4vh;
	font-weight: bold;
	color: white;
	border-radius: 10px;
	padding: 0.2vw 0px 0px 1vw;
}
.qrTitlexs {
	font-size: 3vh;
	font-weight: bold;
	color: white;
	border: 3px solid white;
	border-radius: 10px;
	padding: 0.2vw 0px 0px 1vw;
}
// 상단 버튼
.iconBtn {
	cursor: pointer;
	margin: 0px 5vw 0px 0px;
}
/// 인증완료 메세지 div
.confirmation {
	z-index: 1;
	position: inherit;
	width: 100%;
	text-align: -webkit-center;
	padding-top: 4vh;
}
/// 인증완료 메세지 카드
.alertCard1 {
	opacity: 0.7;
	width: 40vh;
	font-size: 2vh;
	padding: 10px;
	border-radius: 10px !important;
}
.alertCard2 {
	color: white !important;
	opacity: 0.7;
	width: 40vh;
	font-size: 2vh;
	padding: 10px;
	border-radius: 10px !important;
}
/// qr 인식 layout
.qrMiddle {
	z-index: 2;
	height: 84%;
}
.qrMiddlexs {
	z-index: 2;
	height: 86%;
}
// qr 인식 박스
.middleSquare {
	border: 4px dashed yellow;
	width: 30%;
	height: 69.5%;
}
.middleSquaremd {
	border: 4px dashed yellow;
	width: 48vw;
	height: 55vh;
}
.middleSquaresm {
	border: 4px dashed yellow;
	width: 58vw;
	height: 50vh;
}
.middleSquarexs {
	border: 4px dashed yellow;
	width: 63vw;
	height: 30vh;
}
.middleSquarexxs {
	border: 4px dashed yellow;
	width: 71vw;
	height: 30vh;
}
.middleSquarexxxs {
	border: 4px dashed yellow;
	width: 71vw;
	height: 25.5vh;
}
.hideBtn {
	display: none;
}
</style>
